import { TableColumn } from '../../models';
import { UserInfoCellComponent, UserInfoCellProps } from './user-info.component';

export class UserInfoColumn<I> extends TableColumn<I, UserInfoCellProps> {
  readonly component = UserInfoCellComponent;
}
